import { Component, OnInit, inject } from '@angular/core';

import { SidebarComponent } from '../components/navigation/navigation.component';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
  LogoConfig,
  NavigationItem,
  NavigationService,
} from '../core/navigation/navigation.service';
import { filter } from 'rxjs';

@Component({
  selector: 'lib-authenticated-layout',
  standalone: true,
  imports: [SidebarComponent, RouterOutlet],
  templateUrl: './authenticated-layout.component.html',
  styleUrl: './authenticated-layout.component.css',
})
export class AuthenticatedLayoutComponent implements OnInit {
  private navigationService = inject(NavigationService);
  private router = inject(Router);

  navigation: NavigationItem[] = [];
  logo: LogoConfig = {
    type: 'image',
    src: 'assets/logo.png',
    alt: 'Logo',
  };

  constructor() {
    this.navigation = this.navigationService.navigation;
  }

  ngOnInit() {
    this.navigationService.navigationChanges.subscribe((nav) => {
      this.navigation = nav;
    });
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      console.log('NavigationEnd', this.router.url);
      this.navigationService.setCurrentNavigationItem(this.router.url);
    });
  }
}
